import { render, staticRenderFns } from "./SalesStatistics.vue?vue&type=template&id=08a7bce0&scoped=true"
import script from "./SalesStatistics.vue?vue&type=script&lang=ts"
export * from "./SalesStatistics.vue?vue&type=script&lang=ts"
import style0 from "./SalesStatistics.vue?vue&type=style&index=0&id=08a7bce0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7bce0",
  null
  
)

export default component.exports